import script from "./BaseHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseHeader.vue?vue&type=script&setup=true&lang=ts"

import "./BaseHeader.vue?vue&type=style&index=0&id=75a33955&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75a33955"]])

export default __exports__